import styled from 'styled-components';

export const Wrapper = styled('div')`
  max-height: 60vh;
  max-width: 500px;
  .button {
    border: none;
    cursor: pointer;
    background: #0a77c7;
    border-radius: 4px;
    padding: 10px 24px;
    color: #ffffff;
    font-weight: 500;
    font-size: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: auto;
    &:hover {
      transition: 200ms;
      background-color: #003e6e;
    }
  }

  @media only screen and (max-width: 550px) {
    width: 100vw;
    padding: 0 16px;
  }
`;

export const ContactWrapper = styled('div')`
  .title {
    font-size: 20px;
    font-weight: bold;
    margin: 16px 0;
    width: 100%;
    text-align: center;
  }
  .text {
    p {
    font-size: 24px;
      &:nth-child(1){
        text-align: center;
        font-weight: bold;
        font-size: 28px;
        margin-bottom: 20px
    }
  }

  @media only screen and (max-width: 550px) {
    .title {
      font-size: 16px;
      margin: 12px 0;
    }

    .text {
      font-size: 14px;
    }
  }
`;
